// extracted by mini-css-extract-plugin
module.exports = {"close":"T_bN","light":"T_s","icon":"T_bJ"};